import update from 'immutability-helper';
import flatulence from 'flatulence';
import { combineReducers } from 'redux';
import { get, set, map, filter, reduce, isEmpty, includes } from 'lodash';
import { buildUiFacets } from '../utils/index'
import {
  RECALLS,
  FILTER_NODE_EXPAND,
  FILTER_NODE_COLLAPSE,
  FACET_TOGGLE_COLLAPSE,
  FACET_SPOTLIGHT_CHANGE,
} from '../actions/types';
import { UI_FACET_CATEGORY } from '../utils/constants';
import { isLoadingReducer, loadedQueryReducer } from './helpers';

const data = (state = [], action) => {
  switch (action.type) {
    case RECALLS.SUCCESS: {
      const { response } = action.payload;
      return map(response.results, r => ({
        ...r,
        id: r.uri,
      }));
    }
    default:
      return state;
  }
};

const loadedQuery = loadedQueryReducer(RECALLS);

const responseInfo = (state = null, action) => {
  switch (action.type) {
    case RECALLS.SUCCESS: {
      const tryGetNumber = input => /^\d+$/.test(input) ? parseFloat(input) : null;
      return {
        total: tryGetNumber(get(action, 'payload.response.total')),
        pageLength: tryGetNumber(get(action, 'payload.response.page-length')),
        start: tryGetNumber(get(action, 'payload.response.start')),
        end: tryGetNumber(get(action, 'payload.response.end')),
      };
    }
    default:
      return state;
  }
};

const isFething = isLoadingReducer(RECALLS);

const expandedFacetBlocks = (state = [UI_FACET_CATEGORY], action) => {
  switch (action.type) {
    case FACET_TOGGLE_COLLAPSE: {
      const { blockId } = action.payload;
      const isRemove = includes(state, blockId);
      return isRemove ? filter(state, x => x !== blockId) : [...state, blockId];
    }
    default:
      return state;
  }
};

const facetSpotlightSearches = (state = {}, action) => {
  switch (action.type) {
    case FACET_SPOTLIGHT_CHANGE: {
      const { facetId, change } = action.payload;
      return {
        ...state,
        [facetId]: change,
      }
    }
    default:
      return state;
  }
};

const facetExpandedNodesInfo = (state = {}, action) => {
  switch (action.type) {
    case FILTER_NODE_EXPAND:
    case FILTER_NODE_COLLAPSE: {
      const { filterId, node } = action.payload;
      const expandedNodeIds = get(state, `${filterId}`, []);
      const nextExpandedNodeIds = !node.isExpanded
        ? [...expandedNodeIds, node.id] : filter(expandedNodeIds, x => x !== node.id);
      return {
        ...state,
        [filterId]: nextExpandedNodeIds,
      }
    }
    default:
      return state;
  }
};

const availableFacets = (state = {}, action) => {
  switch (action.type) {
    case RECALLS.SUCCESS: {
      const { response, query, expandedNodeIds } = action.payload;
      return buildUiFacets(response.facets, query, expandedNodeIds);
    }
    case FILTER_NODE_EXPAND:
    case FILTER_NODE_COLLAPSE: {
      const { filterId, node } = action.payload;
      const nodePath = map(node.path, p => `[${p}]`).join('.childNodes.');
      return update(state, flatulence.unflatten({
        [`${filterId}.data.${nodePath}.isExpanded.$set`]: !node.isExpanded,
      }));
    }
    default:
      return state;
  }
};

export default combineReducers({
  data,
  responseInfo,
  isFething,
  loadedQuery,
  availableFacets,
  expandedFacetBlocks,
  facetSpotlightSearches,
  facetExpandedNodesInfo,
});



// WEBPACK FOOTER //
// ./src/reducers/recalls.js